module.exports = __webpack_public_path__ + "media/PAG70-01.e1bb2973.mp3";